import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { LogRocketService } from './logrocket.service';

export function provideLogRocket(enabled?: boolean, appId?: string): EnvironmentProviders[] {
  if (!(enabled && appId)) {
    return [];
  }

  return [
    provideAppInitializer(() => {
      const logRocketService = inject(LogRocketService);

      logRocketService.initialize(appId);
    }),
  ];
}
